import api from './api';

// Normalize a single news item from the API response shape to the frontend shape
const normalizeNews = (item) => ({
  id: item.id,
  slug: item.slug,
  title: item.title,
  excerpt: item.excerpt,
  content: item.content,
  status: item.status,
  author: item.author || 'Admin',
  featuredImage: Array.isArray(item.images) && item.images.length > 0 ? item.images[0] : null,
  images: item.images || [],
  createdAt: item.created_at,
  updatedAt: item.updated_at,
});

export const newsService = {
  getAll: async (params = {}) => {
    const apiParams = {
      page: params.page || 1,
      per_page: params.limit || 10,
      ...(params.search ? { search: params.search } : {}),
      ...(params.status ? { status: params.status } : {}),
    };
    const response = await api.get('/news', { params: apiParams });
    const pagination = response.data.data;
    return {
      data: {
        news: (pagination.data || []).map(normalizeNews),
        total: pagination.total,
        page: pagination.current_page,
        totalPages: pagination.last_page,
      }
    };
  },

  getBySlug: async (slug) => {
    const response = await api.get(`/news/${slug}`);
    // Support both { data: item } and { data: { data: item } } shapes
    const item = response.data.data ?? response.data;
    return { data: normalizeNews(item) };
  },

  create: async (data) => {
    const payload = {
      title: data.title,
      excerpt: data.excerpt,
      content: data.content,
      status: data.status || 'draft',
      images: data.featuredImage
        ? [data.featuredImage?.preview || data.featuredImage]
        : []
    };
    return api.post('/news', payload);
  },

  update: async (slug, data) => {
    const payload = {
      title: data.title,
      excerpt: data.excerpt,
      content: data.content,
      status: data.status || 'draft',
      images: data.featuredImage
        ? [data.featuredImage?.preview || data.featuredImage]
        : []
    };
    return api.post(`/news/update/${slug}`, payload);
  },

  delete: async (slug) => {
    return api.delete(`/news/${slug}`);
  },

  toggleStatus: async (slug) => {
    return api.patch(`/news/${slug}/toggle-status`);
  }
};
